import { TenantAccess, TenantPermission, TenantPermissionScope, TenantRestrictionScope } from '@/entities'
import { ObjectId, isNullObjectId } from '@/utils/objectid'

export const hasTenantPermissions = (
    tenantAccess: Pick<TenantAccess, 'owner' | 'permissions' | 'restrictions'> | null | undefined,
    permissions: Partial<Record<TenantPermissionScope, Partial<TenantPermission>>>,
    object: ObjectId | undefined | false | ((scope: TenantRestrictionScope) => ObjectId | undefined) = undefined,
    errors: string[] | undefined = []
): boolean => {
    if (!tenantAccess) {
        return false
    }

    if (tenantAccess.owner) {
        return true
    }

    let scope: TenantPermissionScope
    for (scope in permissions) {
        const requiredPermissions = permissions[scope]
        const availablePermissions = tenantAccess.permissions[scope]

        if (requiredPermissions?.read && !availablePermissions?.read) {
            errors.push(`${scope}.read`)
        }

        if (requiredPermissions?.insert && !availablePermissions?.insert) {
            errors.push(`${scope}.insert`)
        }

        if (requiredPermissions?.edit && !availablePermissions?.edit) {
            errors.push(`${scope}.edit`)
        }

        if (requiredPermissions?.remove && !availablePermissions?.remove) {
            errors.push(`${scope}.remove`)
        }

        if (object !== false) {
            // @ts-expect-error not sure how to fix this
            if (tenantAccess.restrictions?.[scope]?.length) {
                if (object === undefined) {
                    errors.push(`${scope}.restricted`)
                } else {
                    const restrictionScope = scope as TenantRestrictionScope
                    let theObject: ObjectId | undefined = undefined

                    if (typeof object === 'function') {
                        theObject = object(restrictionScope)
                    } else {
                        theObject = object
                    }

                    // Let the "null" object go through
                    if (theObject && !isNullObjectId(theObject)) {
                        const idToSearch = theObject.toString()
                        const objects = tenantAccess.restrictions[restrictionScope]!
                        if (!objects.find((id: ObjectId) => id.toString() === idToSearch)) {
                            errors.push(`${scope}.restricted`)
                        }
                    }
                }
            }
        }
    }

    return errors.length === 0
}
